import React from 'react';
var pic1 = require('../../assets/images/testimonials/pic1.jpg');
var pic2 = require('../../assets/images/testimonials/pic2.jpg');
var pic3 = require('../../assets/images/testimonials/pic3.jpg');

const  TestimonialsGridBlock = (props) => {
  return(	
  <>	  	
	{/* <!-- SECTION CONTENT START --> */} 
	<div className="section-full bg-repeat p-t100 p-b70">
	
		<div className="container">
			
			{/* <!-- TITLE START --> */}   
			<div className="section-head text-center">
				<h2><span className="site-text-primary">Our </span>Non Teaching Staff</h2>
				<div className="wt-separator-outer ">
					<div className="wt-separator style-icon">
						<i className="fa fa-leaf text-black"></i>
						<span className="separator-left site-bg-primary"></span>
						<span className="separator-right site-bg-primary"></span>
					</div>                            
				</div>
				<p>{process.env.REACT_APP_SITE_TITLE} offers a comprehensive educational experience with a diverse team of qualified educators. Here are some staff roles:</p>
			</div>
			{/* <!-- TITLE START --> */}			
			
			{/* <!-- TESTIMONIAL GRID STYLE 3 --> */}    
			<div className="section-content">
				<div className="row testimonial-grid">
						
					<div className="col-md-4 m-b30">
						<div className="testimonial-grid-3">
						
							<div className="quote-left"></div>
							<div className="testimonial-text">
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </p>
							</div>
							<div className="testimonial-detail">
								<strong className="testimonial-name">David Matin</strong>
								<span className="testimonial-position">Cfo, Era tech</span>
							</div>
							<div className="testimonial-pic radius shadow"><img src={pic1} width="100" height="100" alt="" /></div>
							
						</div>
					</div>
					
					<div className="col-md-4 m-b30">
						<div className="testimonial-grid-3">
						
							<div className="quote-left"></div>
							<div className="testimonial-text">
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </p>
							</div>
							<div className="testimonial-detail">
								<strong className="testimonial-name">Ariol Perry</strong>
								<span className="testimonial-position">Designer</span>
							</div>
							<div className="testimonial-pic radius shadow"><img src={pic2} width="100" height="100" alt="" /></div>
							
						</div>
					</div>
					
					<div className="col-md-4 m-b30">
						<div className="testimonial-grid-3">
						
							<div className="quote-left"></div>
							<div className="testimonial-text">
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </p>
							</div>
							<div className="testimonial-detail">
								<strong className="testimonial-name">Lulla Smith</strong>
								<span className="testimonial-position">Cfo, Era tech</span>
							</div>
							<div className="testimonial-pic radius shadow"><img src={pic3} width="100" height="100" alt="" /></div>
							
						</div>
					</div>
					
					<div className="col-md-4 m-b30">
						<div className="testimonial-grid-3">
						
							<div className="quote-left"></div>
							<div className="testimonial-text">
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </p>
							</div>
							<div className="testimonial-detail">
								<strong className="testimonial-name">Resa Smith</strong>
								<span className="testimonial-position">Cfo, Walmart</span>
							</div>
							<div className="testimonial-pic radius shadow"><img src={pic1} width="100" height="100" alt="" /></div>
							
						</div>
					</div>
					
					<div className="col-md-4 m-b30">
						<div className="testimonial-grid-3">
						
							<div className="quote-left"></div>
							<div className="testimonial-text">
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </p>
							</div>
							<div className="testimonial-detail">
								<strong className="testimonial-name">Alan Monre</strong>
								<span className="testimonial-position">Cfo Loop Inc</span>
							</div>
							<div className="testimonial-pic radius shadow"><img src={pic2} width="100" height="100" alt="" /></div>
							
						</div>
					</div>
					
					<div className="col-md-4 m-b30">
						<div className="testimonial-grid-3">
						
							<div className="quote-left"></div>
							<div className="testimonial-text">
								<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard </p>
							</div>
							<div className="testimonial-detail">
								<strong className="testimonial-name">Lulla Smith</strong>
								<span className="testimonial-position">Creative Designer.</span>
							</div>
							<div className="testimonial-pic radius shadow"><img src={pic3} width="100" height="100" alt="" /></div>
							
						</div>
					</div>     
										   
				</div>
			</div>
			
		</div>
		
	</div>
	{/* <!-- SECTION CONTENT END --> */}   
  </>
  )
}
 export default TestimonialsGridBlock;